import isMultiShare from './isMultiShare.js'
export default roomType => isMultiShare(roomType) ? 'quadShare' : roomType
